module.exports = __webpack_public_path__ + "static/media/human-advantage-phone.b077a0d6.svg";